import { render, staticRenderFns } from "./ArtistCredits.vue?vue&type=template&id=0888ff19&"
import script from "./ArtistCredits.vue?vue&type=script&lang=js&"
export * from "./ArtistCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports